import type { FC } from "react";

import dompurify from "isomorphic-dompurify";

import type { DirectionalIconComponent } from "@jti/brand-icons";

import styles from "./IconDescriptionCard.module.scss";

export type IconDescriptionCardProps = {
  title: string;
  text: string;
  icon: DirectionalIconComponent;
};

const { sanitize } = dompurify;

export const IconDescriptionCard: FC<IconDescriptionCardProps> = ({ text, title, icon: Icon }) => {
  return (
    <div className={styles.iconDescriptionCard}>
      <div className={styles.iconHolder}>
        <Icon className={styles.icon} />
      </div>
      <div className={styles.contentHolder}>
        <div className={styles.title}>{title}</div>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: sanitize(text) }}></div>
      </div>
    </div>
  );
};
